<template>
  <div class="layer type_alert" style="display: block">
    <div class="layer_cont">
      <slot>
      </slot>
    </div>
    <div class="pop_btn_area">
      <ul class="btn_lst">
        <li v-show="showCancelButton" class="btn_item btn_cancel">
          <button @click="$emit('confirm', false)" type="button" class="btn_cancel">취소</button>
        </li>
        <li class="btn_item btn_conform">
          <button @click="$emit('confirm', true)" type="button" class="btn_ok">확인</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {defineComponent} from "vue";

  export default defineComponent({
    name: "popup-component",
    props: ['showCancelButton']
  });
</script>

<style scoped>

</style>